import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index.ts';

export const selectUserInfo = (state: RootState) => state.app.user;

export const selectUserIdentifications = (state: RootState) => state.app.user?.identifications;

export const selectUserAFM = createSelector(
  [selectUserIdentifications],
  (identifications) => identifications?.find((id) => id.identifierType === 'AFM')?.identifierValue
);

export const selectUserPreferences = (state: RootState) => state.app.userPreferences;

export const selectInboxStatus = (state: RootState) => state.app.inboxStatus;

export const selectPushNotifications = (state: RootState) => state.app.pushNotifications;

export const selectAppStoreUrls = (state: RootState) => state.app.info.storeUrls;

export const selectIsMobileVersionCompatible = (state: RootState) => state.app.info.isMobileVersionCompatible;

export const selectIsThereANewerMobileVersionAvailable = (state: RootState) =>
  state.app.info.isThereANewerMobileVersionAvailable;
